import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section 
      className="py-24 bg-gradient-to-br from-teal-600 via-cyan-600 to-blue-600 relative overflow-hidden"
      aria-labelledby="cta-heading"
    >
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <article className="text-center text-white">
          <header>
            <h2 id="cta-heading" className="text-4xl lg:text-5xl font-bold mb-6">
              <strong>准备开始您的文档数字化之旅？</strong>
            </h2>
            <p className="text-xl lg:text-2xl mb-10 max-w-3xl mx-auto leading-relaxed">
              立即联系我们，获取<strong>专业的解决方案</strong>和<strong>技术支持</strong>
            </p>
          </header>
          <nav className="flex flex-col sm:flex-row gap-4 justify-center" aria-label="行动号召">
            <Link 
              to="/contact"
              className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
              aria-label="联系我们获取解决方案"
            >
              联系我们
            </Link>
            <Link 
              to="/products"
              className="border-2 border-white text-white hover:bg-white hover:text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-flex items-center justify-center"
              aria-label="查看所有产品"
            >
              查看产品
            </Link>
          </nav>
        </article>
      </div>
    </section>
  );
}
